export const UNIQUE_EMAIL_ERROR = 'Emails should be unique';

export const RECIPIENT_SUCCESS_MESSAGE = 'Recipients updated successfully.';